import { render, staticRenderFns } from "./headerAside.vue?vue&type=template&id=b05beac8&scoped=true&"
import script from "./headerAside.vue?vue&type=script&lang=js&"
export * from "./headerAside.vue?vue&type=script&lang=js&"
import style0 from "./headerAside.vue?vue&type=style&index=0&id=b05beac8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b05beac8",
  null
  
)

export default component.exports